module.exports = __webpack_public_path__ + "static/media/hover_image_news.ce146763.png";